import { useMenu } from '@if/mui'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { ELoanCalendarAction, useLoanCalendarAction } from '../LoanCalendarActionProvider'

interface Props {
  id: string
}

const LoanCalendarTableCellActions = ({ id }: Props) => {
  const { t } = useTranslation()
  const [buttonProps, menuProps, handleMenuClose] = useMenu()
  const { setSelectedPaymentIds, dispatchAction } = useLoanCalendarAction()

  const handleAction = (action: ELoanCalendarAction) => () => {
    setSelectedPaymentIds(new Set([id]))
    dispatchAction(action)
    handleMenuClose()
  }

  return (
    <>
      <IconButton {...buttonProps}>
        <MoreVertIcon />
      </IconButton>
      <Menu {...menuProps}>
        <MenuItem onClick={handleAction(ELoanCalendarAction.OpenEditPaymentsDialog)}>
          <ListItemIcon>
            <EditIcon />
          </ListItemIcon>
          <ListItemText>{t('loan.payment.options.edit')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleAction(ELoanCalendarAction.OpenDeletePaymentsDialog)} sx={{ color: 'error.main' }}>
          <ListItemIcon sx={{ color: 'inherit' }}>
            <DeleteIcon />
          </ListItemIcon>
          <ListItemText>{t('loan.payment.options.delete')}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  )
}

export default memo(LoanCalendarTableCellActions)
